module.exports = "https://coursera_assets.s3.amazonaws.com/images/aab193a35669c730da66edaa197a0407.svg";